import { ICurrency } from './currency.interface';

export interface ICurrencies {
  [key: string]: ICurrency;
}
